export class RiderLoyaltyApi {
    client;
    constructor(client) {
        this.client = client;
    }
    /** Open a loyalty account for a rider against a tier ladder. */
    openAccount(input) {
        return this.client.request({ method: 'POST', path: '/v1/rider-loyalty/accounts', body: input, auth: true });
    }
    /** Earn points (the tier re-derives from the ladder). */
    earn(accountId, delta, ladder) {
        return this.client.request({ method: 'POST', path: `/v1/rider-loyalty/accounts/${encodeURIComponent(accountId)}/earn`, body: { delta, ladder }, auth: true });
    }
    /** Redeem points (fails closed on an insufficient balance → 409). */
    redeem(accountId, cost, ladder) {
        return this.client.request({ method: 'POST', path: `/v1/rider-loyalty/accounts/${encodeURIComponent(accountId)}/redeem`, body: { cost, ladder }, auth: true });
    }
    /** Read a loyalty account. */
    getAccount(accountId) {
        return this.client.request({ method: 'GET', path: `/v1/rider-loyalty/accounts/${encodeURIComponent(accountId)}`, auth: true });
    }
    /** List a rider's loyalty accounts (newest first). */
    listAccounts(riderId) {
        return this.client.request({ method: 'GET', path: `/v1/rider-loyalty/accounts?riderId=${encodeURIComponent(riderId)}`, auth: true });
    }
    /** Start a subscription (plan tax + consumer terms are snapshotted at start). */
    startSubscription(input) {
        return this.client.request({ method: 'POST', path: '/v1/rider-loyalty/subscriptions', body: input, auth: true });
    }
    /** Cancel a subscription — the refund is computed from the snapshotted terms. */
    cancelSubscription(subscriptionId) {
        return this.client.request({ method: 'POST', path: `/v1/rider-loyalty/subscriptions/${encodeURIComponent(subscriptionId)}/cancel`, body: {}, auth: true });
    }
    /** Expire a lapsed subscription. */
    expireSubscription(subscriptionId) {
        return this.client.request({ method: 'POST', path: `/v1/rider-loyalty/subscriptions/${encodeURIComponent(subscriptionId)}/expire`, body: {}, auth: true });
    }
    /** Read a subscription. */
    getSubscription(subscriptionId) {
        return this.client.request({ method: 'GET', path: `/v1/rider-loyalty/subscriptions/${encodeURIComponent(subscriptionId)}`, auth: true });
    }
    /** List a rider's subscriptions (newest first). */
    listSubscriptions(riderId) {
        return this.client.request({ method: 'GET', path: `/v1/rider-loyalty/subscriptions?riderId=${encodeURIComponent(riderId)}`, auth: true });
    }
}
//# sourceMappingURL=rider-loyalty.js.map